import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    currentUser: null,
    loading: false,
    error: null,
    selectedAccountId: null,
    selectedAccount: null,
};
const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUser: (state, action) => {
            const { user } = action.payload;
            state.currentUser = user;
            state.loading = false;
            state.error = null;
        },
        updateUser: (state, action) => {
            const { updates } = action.payload;
            if (state.currentUser) {
                state.currentUser = { ...state.currentUser, ...updates };
            }
            state.loading = false;
            state.error = null;
        },
        clearUser: state => {
            state.currentUser = null;
            state.loading = false;
            state.error = null;
            state.selectedAccountId = null;
            state.selectedAccount = null;
        },
        setUserLoading: (state, action) => {
            state.loading = action.payload;
        },
        setUserError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
        setSelectedAccountId: (state, action) => {
            state.selectedAccountId = action.payload;
        },
        setSelectedAccount: (state, action) => {
            state.selectedAccount = action.payload;
        },
    },
});
export const { setUser, updateUser, clearUser, setUserLoading, setUserError, setSelectedAccountId, setSelectedAccount, } = userSlice.actions;
export default userSlice.reducer;
